/* floral-quiz.js
   Paste this entire file into Shopify: Assets -> Add a new asset -> Create a blank file -> floral-quiz.js
   Then include it with: <script src="{{ 'floral-quiz.js' | asset_url }}" defer></script> in theme.liquid before </body>
*/

/* Script: runs after the HTML. Exposes debug helpers. Responsive question font (25px desktop, 16px mobile) */
window.__floralQuizScriptLoaded = true;

const IMAGES = {
  intro: "https://cdn.shopify.com/s/files/1/0852/0366/files/intro.jpg?v=1760550676",
  Q1: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q1.jpg?v=1760550340",
  Q2: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q2.jpg?v=1760550324",
  Q3: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q3.jpg?v=1760550278",
  Q4: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q4.jpg?v=1760550362",
  Q5: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q5.jpg?v=1760550406",
  Q6: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q6.jpg?v=1760550434",
  Q7: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q7.jpg?v=1760550458",
  Q8: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q8.jpg?v=1760550478",
  Q9: "https://cdn.shopify.com/s/files/1/0852/0366/files/Q9.jpg?v=1760550254",
  end: "https://cdn.shopify.com/s/files/1/0852/0366/files/end.jpg?v=1760550225",
  pink: "https://cdn.shopify.com/s/files/1/0852/0366/files/pink.jpg?v=1760546975",
  red: "https://cdn.shopify.com/s/files/1/0852/0366/files/red.jpg?v=1760546958",
  orange: "https://cdn.shopify.com/s/files/1/0852/0366/files/orange.jpg?v=1760546970",
  yellow: "https://cdn.shopify.com/s/files/1/0852/0366/files/yellow.jpg?v=1760546934",
  green: "https://cdn.shopify.com/s/files/1/0852/0366/files/green.jpg?v=1760546953",
  blue: "https://cdn.shopify.com/s/files/1/0852/0366/files/blue.jpg?v=1760546947",
  purple: "https://cdn.shopify.com/s/files/1/0852/0366/files/purple.jpg?v=1760546963"
};

// your weighted questions (unchanged)
const questions = [
  { text: "In a sunlit room filled with swirling petals, an artist places a brush in your hand. How do you paint?", image: IMAGES.Q1, options: [
    { text: "On a canvas", picks: [{colour: "Pink", w: 0.6}, {colour: "Yellow", w: 0.4}] },
    { text: "On the walls around you", picks: [{colour: "Green", w: 0.6}, {colour: "Purple", w: 0.4}] },
    { text: "On any surface that inspires you", picks: [{colour: "Purple", w: 0.6}, {colour: "Blue", w: 0.4}] }
  ]},
  { text: "Soft music drifts from three hidden doorways. Which do you choose?", image: IMAGES.Q2, options: [
    { text: "A wooden door", picks: [{colour: "Green", w: 0.6}, {colour: "Purple", w: 0.4}] },
    { text: "A glass door", picks: [{colour: "Red", w: 0.6}, {colour: "Blue", w: 0.4}] },
    { text: "A metal door", picks: [{colour: "Blue", w: 0.6}, {colour: "Red", w: 0.4}] }
  ]},
  { text: "A familiar fragrance fills the air. Which scent draws you in?", image: IMAGES.Q3, options: [
    { text: "Fresh, rain-kissed lilies", picks: [{colour: "Purple", w: 0.6}, {colour: "Green", w: 0.4}] },
    { text: "Warm cinnamon and tuberose", picks: [{colour: "Pink", w: 0.6}, {colour: "Red", w: 0.4}] },
    { text: "Sweet, blooming peonies", picks: [{colour: "Orange", w: 0.6}, {colour: "Pink", w: 0.4}] }
  ]},
  { text: "Which seat feels like yours?", image: IMAGES.Q4, options: [
    { text: "Colourful accents with cheerful details", picks: [{colour: "Yellow", w: 0.6}, {colour: "Orange", w: 0.4}] },
    { text: "Minimalist with black-and-white tones", picks: [{colour: "Green", w: 0.6}, {colour: "Blue", w: 0.4}] },
    { text: "Neutral or earthy colour palettes", picks: [{colour: "Pink", w: 0.6}, {colour: "Green", w: 0.4}] }
  ]},
  { text: "Which end point do you choose?", image: IMAGES.Q5, options: [
    { text: "A peaceful garden at sunrise", picks: [{colour: "Blue", w: 0.6}, {colour: "Green", w: 0.4}] },
    { text: "A lively festival full of laughter", picks: [{colour: "Yellow", w: 0.6}, {colour: "Orange", w: 0.4}] },
    { text: "A quiet, hidden corner that’s cosy and inviting", picks: [{colour: "Purple", w: 0.6}, {colour: "Pink", w: 0.4}] }
  ]},
  { text: "A florist offers three bouquets. Which one do you gladly receive?", image: IMAGES.Q6, options: [
    { text: "Soft, pastel blooms", picks: [{colour: "Green", w: 0.6}, {colour: "Pink", w: 0.4}] },
    { text: "Bright, vibrant flowers", picks: [{colour: "Orange", w: 0.6}, {colour: "Yellow", w: 0.4}] },
    { text: "Bold, rich colours", picks: [{colour: "Red", w: 0.6}, {colour: "Purple", w: 0.4}] }
  ]},
  { text: "Which wedding dress style would you choose?", image: IMAGES.Q7, options: [
    { text: "Elegant and flowing", picks: [{colour: "Blue", w: 0.6}, {colour: "Purple", w: 0.4}] },
    { text: "Soft and delicate", picks: [{colour: "Pink", w: 0.6}, {colour: "Green", w: 0.4}] },
    { text: "Bold and dramatic", picks: [{colour: "Red", w: 0.6}, {colour: "Orange", w: 0.4}] }
  ]},
  { text: "Which treat would you choose?", image: IMAGES.Q8, options: [
    { text: "A delicate pastry adorned with edible flowers", picks: [{colour: "Blue", w: 0.6}, {colour: "Pink", w: 0.4}] },
    { text: "A rich chocolate dessert", picks: [{colour: "Red", w: 0.6}, {colour: "Yellow", w: 0.4}] },
    { text: "A fresh fruit tart bursting with colour", picks: [{colour: "Orange", w: 0.6}, {colour: "Pink", w: 0.4}] }
  ]},
  { text: "Which beautifully wrapped gift would you take home?", image: IMAGES.Q9, options: [
    { text: "A handcrafted glass bloom", picks: [{colour: "Purple", w: 0.6}, {colour: "Blue", w: 0.4}] },
    { text: "A piece of exquisite plateware", picks: [{colour: "Yellow", w: 0.6}, {colour: "Pink", w: 0.4}] },
    { text: "A beautiful vase of fresh flowers", picks: [{colour: "Red", w: 0.6}, {colour: "Orange", w: 0.4}] }
  ]},
];

// results mapping
const results = {
  Pink:   {img: IMAGES.pink },
  Red:    {img: IMAGES.red },
  Orange: {img: IMAGES.orange },
  Yellow: {img: IMAGES.yellow },
  Green:  {img: IMAGES.green },
  Blue:   {img: IMAGES.blue },
  Purple: {img: IMAGES.purple }
};

const endingImageUrl = IMAGES.end;

let currentIndex = 0;
const picks = [];
const AUTO_ADVANCE_MS = 450;

/* Select DOM elements after DOMContentLoaded */
function initQuiz() {
  const homeEl = document.getElementById('home');
  const quizEl = document.getElementById('quiz');
  const endingEl = document.getElementById('ending');
  const resultEl = document.getElementById('result');

  const startBtn = document.getElementById('startBtn');
  const seeResultsBtn = document.getElementById('seeResultsBtn');

  const progressEl = document.getElementById('progress');
  const qtextEl = document.getElementById('qtext');
  const qimgEl = document.getElementById('qimg');
  const optionsEl = document.getElementById('options');

  const endingImageEl = document.getElementById('endingImage');
  const endingImageNote = document.getElementById('endingImageNote');

  const resultImgEl = document.getElementById('resultImage');
  const resultImageNote = document.getElementById('resultImageNote');
  const resultNameEl = document.getElementById('resultName');

  function pickWeighted(picksArr) {
    const r = Math.random();
    let acc = 0;
    for (const p of picksArr) {
      acc += p.w;
      if (r <= acc) return p.colour;
    }
    return picksArr[picksArr.length - 1].colour;
  }

  function show(el) {
    homeEl.classList.add('hidden');
    quizEl.classList.add('hidden');
    endingEl.classList.add('hidden');
    resultEl.classList.add('hidden');
    el.classList.remove('hidden');
  }

  function setQuestionFontSize() {
    // desktop 25px, mobile 16px
    const mobileMax = 560;
    const size = (window.innerWidth <= mobileMax) ? 16 : 25;
    qtextEl.style.fontFamily = "'Cormorant Garamond', serif";
    qtextEl.style.fontSize = size + "px";
    qtextEl.style.fontWeight = "700";
    qtextEl.style.color = "#DBC8B6";
  }

  function startQuiz() {
    currentIndex = 0;
    picks.length = 0;
    renderQuestion();
    show(quizEl);
  }

  function renderQuestion() {
    const q = questions[currentIndex];
    progressEl.textContent = `Question ${currentIndex+1} of ${questions.length}`;
    qtextEl.textContent = q.text;

    setQuestionFontSize();

    if (q.image && q.image.trim() !== "") {
      qimgEl.src = q.image;
      qimgEl.style.display = 'block';
    } else {
      qimgEl.style.display = 'none';
    }

    optionsEl.innerHTML = '';
    q.options.forEach((opt, idx) => {
      const div = document.createElement('div');
      div.className = 'option';
      div.textContent = opt.text;
      // ensure Karla inline for options
      div.style.fontFamily = "'Karla', sans-serif";
      div.style.fontSize = "18px";
      div.tabIndex = 0;
      div.addEventListener('click', () => selectOption(idx));
      div.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(idx); }
      });
      optionsEl.appendChild(div);
    });
  }

  let advanceTimer = null;
  function selectOption(optionIndex) {
    const opt = questions[currentIndex].options[optionIndex];
    const chosenColour = pickWeighted(opt.picks);
    picks[currentIndex] = chosenColour;

    const nodes = optionsEl.querySelectorAll('.option');
    nodes.forEach((n,i) => n.classList.toggle('selected', i === optionIndex));

    if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
    advanceTimer = setTimeout(() => {
      if (currentIndex < questions.length - 1) {
        currentIndex++;
        renderQuestion();
      } else {
        showEnding();
      }
    }, AUTO_ADVANCE_MS);
  }

  function showEnding() {
    if (endingImageUrl) {
      const img = new Image();
      img.onload = () => {
        endingImageEl.src = endingImageUrl;
        endingImageEl.style.display = 'block';
        endingImageNote.style.display = 'none';
      };
      img.onerror = () => {
        endingImageEl.style.display = 'none';
        endingImageNote.style.display = 'block';
      };
      img.src = endingImageUrl;
    }
    show(endingEl);
  }

  function showResults() {
    const tally = {};
    for (const c of picks) {
      if (!c) continue;
      tally[c] = (tally[c] || 0) + 1;
    }
    let best = null, bestCount = -1;
    for (const k in tally) {
      if (tally[k] > bestCount) { best = k; bestCount = tally[k]; }
    }
    if (!best) best = 'Pink';

    const r = results[best] || { name: best, img: "" };
    if (r.img) {
      resultImgEl.src = r.img;
      resultImgEl.style.display = 'block';
      resultImageNote.style.display = 'none';
    } else {
      resultImgEl.style.display = 'none';
      resultImageNote.style.display = 'block';
    }
    resultImgEl.alt = r.name;
    resultNameEl.textContent = r.name;
    show(resultEl);
  }

  // expose debug helper
  window.__floralQuizState = () => ({ currentIndex, picks, questions });

  // Wire events
  startBtn.addEventListener('click', startQuiz);
  seeResultsBtn.addEventListener('click', showResults);
  window.addEventListener('resize', setQuestionFontSize);

  // init view
  setQuestionFontSize();
  show(homeEl);

  // expose startQuiz globally as fallback for inline onclick
  window.startQuiz = startQuiz;
}

/* Initialize after DOM ready. If PageFly injects this script late, still try to init */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuiz);
} else {
  initQuiz();
}